<template>
  <div ref="moduleSideBar" id="moduleSideBar" >

    <vs-sidebar parent="#moduleSideBar" class="moduleSidebar" position-right default-index="1"  color="primary"  spacer v-model="isActive">
      <div class="header-sidebar" slot="header">
        <h3 class="font-bold">
          Add a new <span v-if="moduleTypeSought === 'trigger'">trigger </span>module
        </h3>
      </div>
      <ais-instant-search :stalled-search-delay="200" :search-client="customSearchClient" index-name="CLIKR_MODULES" show-loading-indicator>
        <ais-search-box show-loading-indicator />
        <ais-configure
          
            :restrictSearchableAttributes="['module', 'description']"
          />
        <!--<h5 class="font-bold filter-header mb-2">
          Filter By Type:
        </h5>
        <div class="flex flex-wrap justify-start align-top w-full">
          <vs-chip>
            Build
          </vs-chip>
          <vs-chip>
            Test
          </vs-chip>
          <vs-chip>
            Operate
          </vs-chip>
          <vs-chip>
            Release
          </vs-chip>
          <vs-chip>
            Deploy
          </vs-chip>
          <vs-chip>
            Monitor
          </vs-chip>
          <vs-chip>
            Clikr Workflow
          </vs-chip>
        </div>-->

        <ais-hits class="max-h-full moduleList">
          <div slot="item" slot-scope="{ item }">
            <vs-list-item :title="item.title" :subtitle="item.description">
              <template slot="avatar">
                <vs-avatar size="large" color="#fff" :src="'logo' in item ? item.logo : 'https://clikr-modules.s3.amazonaws.com/default.png'"/>
              </template>
              <vs-button icon="add" type="flat" color="success" size="large" @click="pickModule(item)"></vs-button>
            </vs-list-item>
          </div>
        </ais-hits>
        <ais-pagination
        :class-names="{
          'ais-Pagination-list': 'vs-pagination--ul',
          'ais-Pagination-item': 'vs-pagination--li',
          'ais-Pagination-item--selected': 'is-current'
        }"
      />
      </ais-instant-search>
    </vs-sidebar>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  props: {
    active: { type: Boolean },
    id: { type: String },
    moduleAdditionMethod: { type: String },
    moduleTypeSought: { type: String }
  },
  data () {
    return {
      searchParameters: {
        restrictSearchableAttribute: ['module']
      },
      hiddenBackground: true,
      loading: true,
      errored: false,
      request_config: {
        headers: { 'Authorization': `Bearer ${localStorage.jwt}` }
      },
      customSearchClient: {
        search (requests) {
          return fetch(`${process.env.VUE_APP_API_ENDPOINT}/module`, {
            method: 'post',
            headers: {
              'Authorization': `Bearer ${localStorage.jwt}`,
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ requests })
          }).then(res => res.json())
        }
      }
    }
  },
  computed: {
    isActive: {
      get () {
        return this.active
      },
      set (a) {
        this.$emit('updateSideBarState', a)
      }
    }
  },
  methods: {
    toggleModulesSidebar (type, moduleAdditionMethod) {
      const $this = this
      let typeSought = null

      // logic for differentiating between types of modules desired
      // if user is replacing a trigger-placeholder, they'll want a trigger module
      // otherwise they'll want a standard module
      // TODO: will require rework in the case of multiple triggers
      switch (type) {
      case 'trigger-placeholder':
        typeSought = 'trigger'
        break
      default:
        typeSought = 'standard'
      }

      // Sets the module type sought
      // updates filteredModules()
      $this.moduleTypeSought = typeSought
      if (moduleAdditionMethod) {
        $this.moduleAdditionMethod = moduleAdditionMethod
      }
      this.$emit('updateSideBarState', true)
    },
    pickModule (module) {
      const $this = this
      const m = _.cloneDeep(module)

      // TODO: This should be provided on the backend
      m.action_type = 'standard'

      m.title = m['title']
      m.children = []
      m.id = m.objectID
      m.value = {}
      delete m.__position
      delete m._highlightResult
      delete m._tags
      delete m.author
      delete m.versions
      delete m.description
      delete m.objectID
      console.log(m)
      // console.log('pickModule() --', module)
      if ($this.moduleAdditionMethod  === 'add-child') {
        // run addChild method inside the Grid component
        $this.$parent.$refs.grid.addChild($this.$parent.$refs.grid.focusedModule.id, m)
      } else if ($this.moduleAdditionMethod  === 'add-child-between') {
        // run addChildBetween method inside the Grid component
        $this.$parent.$refs.grid.addChildBetween($this.$parent.$refs.grid.focusedModule.id, m)
      } else {
        $this.$parent.$refs.grid.addChild(null, m)
      }
      $this.isActive = false
    }
  }
}
</script>
<style>
#moduleSideBar .vs-sidebar--items {
  overflow-y: scroll !important;
  padding-right: 20px !important;
  height: 88% !important;
}
.ais-Pagination {
  position: absolute;
  bottom: 0;
  margin-bottom: 20px;
  right: 22%;
}
.is-current {
  opacity: 1;
  -webkit-transform: scale(1)!important;
  transform: scale(1)!important;
  -webkit-box-shadow: 0 0 20px 0 var(--vs-color-pagination-alpha);
  box-shadow: 0 0 20px 0 var(--vs-color-pagination-alpha);
  background: rgba(var(--vs-primary),1)!important;
  border-radius: 25%;
}
.ais-Pagination-item > span, .ais-Pagination-item > a {
  width: 100%;
  height: 100%;
  text-align: center;
  line-height: 35px;
}
.is-current > a {
  color: #fff !important;
}
#moduleSideBar .vs-sidebar {
  max-width: 720px;
  background-color: #F8F8F8;
  padding: 3em;
}
.vs-avatar--con-img, .vs-avatar--con-img img {
  width: 50px;
  height: 50px;
}
.vs-sidebar--header {
  border-bottom: none;
  padding: 2em 0 1em;
  font-weight: bold;
}
.vs-sidebar--header h3 {
  color: #626262;
}
.filter-header {
  color: #626262;
}
/* .vs-input--placeholder {
    font-size: 1rem;
}
.vs-input--icon {
    font-size: 1.6rem;
    color: rgba(255,255,255);
}
.vuesax-app-is-ltr .vs-input--icon {
    height: 100%;
    padding: 1rem;
    border-radius: 6px 0 0 6px;
    background-color: purple;
} */

.con-vs-chip {
  background: rgba(var(--vs-primary),0);
  color: rgba(var(--vs-primary),1) !important;
  border: 1px solid rgba(var(--vs-primary),1);
}

.vs-sidebar--items {
    padding: unset;
}

/** THE LIST */
.vs-list--item {
  margin: 1em 0;
  padding: 1em;
  background-color: #fff;
  border-radius: 6px;
}

.vs-list--item .vs-list--avatar {
  margin-right: 1em;
}

.moduleList .vs-list {
  position: absolute;
  top: 240px;
  bottom: 0px;
  left: 40px;
  right: 710px;
  overflow-y: scroll;
  width: 646px;
  padding-bottom: 120px;
}

/** SEARCH BOX INPUT */
.ais-SearchBox-form {
  display: flex;
  justify-content: left;
  align-items: center;
  margin-bottom: 1.25rem !important;
}

.ais-SearchBox-form .ais-SearchBox-input {
  flex: 1 1 0%!important;
  border: 1px solid rgba(0, 0, 0, 0.2);
  padding: 0.7rem !important;
  color: inherit;
  position: relative;
  border-radius: 6px 0 0 6px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-box-shadow: 0 0 0 0 rgba(0,0,0,.15);
  box-shadow: 0 0 0 0 rgba(0,0,0,.15);
  -webkit-transition: all .3s ease;
  transition: all .3s ease;

}

.ais-SearchBox-form .ais-SearchBox-input:focus {
  border: 1px solid rgba(var(--vs-primary),1)!important;
}

.ais-SearchBox-form button {
  -webkit-transition: all .2s ease;
  transition: all .2s ease;
  padding: 9.25px 20px;
  border: 0;
  border-radius: 0 6px 6px 0;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  color: #fff;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  background: rgb(var(--vs-primary));
}

.ais-SearchBox-form button:hover {
  background: rgba(var(--vs-primary),.9)!important;
}

.ais-SearchBox-reset {
  display: none !important;
}

.ais-SearchBox-submitIcon {
  width: 15px;
  height: 15px;
  fill: #fff;
}

.ais-SearchBox-loadingIndicator {
  padding: 9.25px 20px;
  border: 1px 1px 1px 0 solid rgba(var(--vs-primary),1);
  border-radius: 0 6px 6px 0;
  position: relative;
  overflow: hidden;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  background: rgba(var(--vs-primary),1);
  height: 36.59px;
}

.ais-SearchBox-loadingIndicator svg {
  stroke: #fff !important;
}
</style>
